// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tj","itemWrapper":"tk rK","itemStyle":"tl rL"};